import { useEffect, useState, useRef } from "react";
import axios from "axios";

const base_url = process.env.REACT_APP_API_URL;

export default function History() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const [type, setType] = useState("all");
  const [date, setDate] = useState("");

  const limit = 5;

  const pageRef = useRef(1);

  // 🔹 Load when filter changes
  useEffect(() => {
    pageRef.current = 1;
    setData([]);
    setHasMore(true);
    loadHistory(true);
  }, [type, date]);

  // 🔹 Scroll handler
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100 &&
        hasMore &&
        !loading
      ) {
        loadHistory();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);

  const loadHistory = async (reset = false) => {
    if (loading) return;

    try {
      setLoading(true);

      const currentPage = reset ? 1 : pageRef.current;

      const res = await axios.get(`${base_url}/api/user-statement`, {
        params: {
          page: currentPage,
          limit,
          date,
          type,
        },
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (res.data.status) {
        const newData = res.data.data;

        if (reset) {
          setData(newData);
          pageRef.current = 2;
        } else {
          setData((prev) => [...prev, ...newData]);
          pageRef.current += 1;
        }

        if (newData.length < limit) {
          setHasMore(false);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-3">
      <h4 className="mb-3">Transaction history</h4>

      {/* Filters */}
      <div className="row g-2 mb-3">
        <div className="col-6">
          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="all">All</option>
            <option value="deposite">Deposite</option>
            <option value="withdraw">Withdraw</option>
            {/* <option value="aviator">Aviator</option> */}
            <option value="matka">Matka</option>
            <option value="lucky7">Lucky7</option>
            <option value="12 Tiles">12 Tiles</option>
            <option value="Mine game">Mine game</option>
            <option value="Win Go">Win Go</option>
            <option value="Spin Wheel">Spin Wheel</option>
          </select>
        </div>

        <div className="col-6">
          <input
            type="date"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
      </div>

      {/* Loader */}
      {loading && (
        <p className="text-center text-primary">Loading...</p>
      )}

      {/* History Cards */}
      {data.map((item, i) => {
        const date = item.created_at
          ? new Date(item.created_at).toLocaleString()
          : "-";

        const category =
          item.category.charAt(0).toUpperCase() +
          item.category.slice(1);

        const remark =
          item.remark.charAt(0).toUpperCase() +
          item.remark.slice(1);

        return (
          <div className="historyCard mb-4" key={i}>
            <div className="historyHeader">{i + 1}. {category}</div>

            <div className="historyBody">
              <div className="rowItem">
                <span>Status</span>

                <span
                  className={
                    item.status === 1
                      ? "text-success"
                      : item.status === 0
                      ? "text-warning"
                      : "text-danger"
                  }
                >
                  {item.status === 1
                    ? "Success"
                    : item.status === 0
                    ? "Pending"
                    : "Failed"}
                </span>
              </div>

              <div className="rowItem">
                <span>Time</span>
                <span>{date}</span>
              </div>

              <div className="rowItem">
                <span>Balance</span>
                <span
                  className={
                    item.status === 1
                      ? "text-success"
                      : "text-danger"
                  }
                >
                  ₹{item.amount}
                </span>
              </div>

              <div className="rowItem">
                <span>Current Balance</span>
                <span className="text-success">
                  ₹{item.current_money}
                </span>
              </div>

              <div className="rowItem">
                <p
                  className={
                    item.status === 1
                      ? "m-0 text-success"
                      : "m-0 text-danger"
                  }
                >
                  {remark}
                </p>
              </div>
            </div>
          </div>
        );
      })}

      {!hasMore && (
        <p className="text-center text-muted">
          No more transactions
        </p>
      )}
    </div>
  );
}